import { styled, media } from "@payright/web-components";

export const SCCustomerFilterStatement = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 1em auto 0;
  height:vh;
  position: relative;
  z-index: 1;

  ${media.max.medium} {
    max-width: 1500px;
  }

  .containerStatement {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: 100%;
    justify-content: flex-end;
    margin: 1em auto 0;

    gap: 10px;

    .button-generate {
      height: 47px;
    }

    ${media.max.medium} {
      flex-direction: column;
      align-items: stretch;
      row-gap: 20px;
      width: fit-content;
    }
  }
`;

export const SCCustomerDateError = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 1em auto 0;
  text-align: center;
  color: ${props => props.theme.colours.blue.base};
  font-size: 1.1em;
  font-weight: bold;
`;

export const Statement = styled.div`
  font-family: Arial, monospace;
`;
